import { getWixSDK } from '../wix-sdk';
import { pubSubPublish } from '../../worker/actions/pub-sub/publish';
import { createProxy } from '../../worker/lib';
import { getCompId } from '../../redux/hydrated-data/hydrated-data';

const VIDEO_OVERLAY_CLOSE_REQUEST = 'VIDEO_OVERLAY_CLOSE_REQUEST';

/**
 * Publish video overlay close request to other instance iframes
 */
export const publishVideoOverlayCloseRequest = createProxy(
  'publishVideoOverlayCloseRequest',
  () => (dispatch, getState) => {
    const rootCompId = getCompId(getState());
    dispatch(
      pubSubPublish(VIDEO_OVERLAY_CLOSE_REQUEST, {
        rootCompId,
      }),
    );
  },
);

export function subscribeVideoOverlayCloseRequest(rootCompId, listener) {
  const WixSDK = getWixSDK();

  let subscriptionId = WixSDK.PubSub.subscribe(
    VIDEO_OVERLAY_CLOSE_REQUEST,
    (event) => {
      if (event.data.rootCompId === rootCompId) {
        listener();
      }
    },
  );

  return function unsubscribeVideoOverlayCloseRequest() {
    if (subscriptionId) {
      WixSDK.PubSub.unsubscribe(VIDEO_OVERLAY_CLOSE_REQUEST, subscriptionId);
      subscriptionId = null;
    }
  };
}
